import { render, staticRenderFns } from "./AccountDeletion.vue?vue&type=template&id=a620a6aa&scoped=true&"
import script from "./AccountDeletion.vue?vue&type=script&lang=js&"
export * from "./AccountDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a620a6aa",
  null
  
)

export default component.exports